import {LocaleType} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/enum/LocaleType'

export function getLocalePrefixFromPath(path: string): LocaleType | null {
  const firstSegment = path.split('/').filter(Boolean)[0]
  if(!firstSegment) {
    return null
  }
  if(Object.values(LocaleType).includes(firstSegment as LocaleType)) {
    return firstSegment as LocaleType
  }
  return null
}
